// We had to disable the rule, because the "fill" and "stroke" attributes of the svg wanted a token, and there's no token for white

/**
 * This file contains the component types metadata that will need to be used throughout the Compass Frontend.
 * Actual field definitions and its options are fetched using a GraphQL query from the Compass Catalog.
 */
import React from 'react';
import type { CustomGlyphProps } from '@atlaskit/icon/types';
import messages from './messages.tsx';

export const OtherIcon = (props: CustomGlyphProps): React.JSX.Element => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991ZM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991V10.01Z"
			fill="#fff"
		/>
		<path
			d="M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335Zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67Zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668Zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67Z"
			fill="#fff"
		/>
	</svg>
);

const componentTypesMetadata = {
	SERVICE: {
		id: 'SERVICE',
		name: messages.service,
		color: (isDarkMode: boolean) => (isDarkMode ? '#8F7EE7' : '#6554C0'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.714 5a1.286 1.286 0 1 0 0 2.571 1.286 1.286 0 0 0 0-2.571Zm-3.143.327A3.287 3.287 0 0 1 21 6.286a3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.042h-1.72L9.738 12l2.828 4.714h1.72a1 1 0 0 1 .285.041 3.287 3.287 0 0 1 6.429.96 3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.041H12a1 1 0 0 1-.857-.485L8.005 13H4a1 1 0 0 1 0-2h4.005l3.137-5.229A1 1 0 0 1 12 5.286h2.286a1 1 0 0 1 .285.04Zm3.143 11.101a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572Z"
					fill="#fff"
				/>
			</svg>
		),
	},
	LIBRARY: {
		id: 'LIBRARY',
		name: messages.library,
		color: (isDarkMode: boolean) => (isDarkMode ? '#F5CD47' : '#FF8B00'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.21667 5C5.80834 5 4.66667 6.14167 4.66667 7.55V11H4.05C3.4701 11 3 11.4701 3 12.05C3 12.6299 3.4701 13.1 4.05 13.1H4.66667V16.55C4.66667 17.9583 5.80834 19.1 7.21667 19.1H9.05C9.6299 19.1 10.1 18.6299 10.1 18.05C10.1 17.4701 9.6299 17 9.05 17H7.21667C6.96814 17 6.76667 16.7985 6.76667 16.55V12.05V7.55C6.76667 7.30147 6.96814 7.1 7.21667 7.1H9.05C9.6299 7.1 10.1 6.6299 10.1 6.05C10.1 5.4701 9.6299 5 9.05 5H7.21667ZM16.8833 19.1C18.2917 19.1 19.4333 17.9583 19.4333 16.55V13.1H20.05C20.6299 13.1 21.1 12.6299 21.1 12.05C21.1 11.4701 20.6299 11 20.05 11H19.4333V7.55C19.4333 6.14167 18.2917 5 16.8833 5L15.05 5C14.4701 5 14 5.4701 14 6.05C14 6.6299 14.4701 7.1 15.05 7.1L16.8833 7.1C17.1319 7.1 17.3333 7.30147 17.3333 7.55V12.05L17.3333 16.55C17.3333 16.7985 17.1319 17 16.8833 17H15.05C14.4701 17 14 17.4701 14 18.05C14 18.6299 14.4701 19.1 15.05 19.1H16.8833Z"
					fill="#fff"
				/>
			</svg>
		),
	},
	APPLICATION: {
		id: 'APPLICATION',
		name: messages.application,
		color: (isDarkMode: boolean) => (isDarkMode ? '#2ABB7F' : '#36B37E'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.57 3.105a1 1 0 0 1 .894.001l3.985 2A1 1 0 0 1 17 6v4.375l3.449 1.731A1 1 0 0 1 21 13v5a1 1 0 0 1-.553.895l-4.004 2a1 1 0 0 1-.894 0l-3.55-1.777-3.556 1.777a1 1 0 0 1-.894 0l-3.997-2A1 1 0 0 1 3 18v-5a1 1 0 0 1 .554-.895L7 10.389V6a1 1 0 0 1 .554-.895l4.016-2Zm-3.563 9.017L5 13.619v3.763l2.997 1.5 3.003-1.5V13.62l-2.993-1.498ZM13 13.619v3.763l2.996 1.5 3.004-1.5v-3.765l-2.986-1.499L13 13.619Zm2-3.237V6.617l-2.986-1.499L9 6.619v3.756l3 1.506 3-1.5Z"
					fill="#fff"
				/>
			</svg>
		),
	},
	CAPABILITY: {
		id: 'CAPABILITY',
		name: messages.capability,
		color: (isDarkMode: boolean) => (isDarkMode ? '#738496' : '#344563'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<mask id="path-4-inside-4_1403_23012" fill="white">
					<rect width="24" height="24" rx="3" fill="#44546F" />
				</mask>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M10.7048 6.76169C10.7048 7.47703 11.2847 8.05693 12 8.05693C12.7154 8.05693 13.2953 7.47703 13.2953 6.76169C13.2953 6.04635 12.7154 5.46646 12 5.46646C11.2847 5.46646 10.7048 6.04635 10.7048 6.76169ZM11.2 9.54498C10.9878 9.48411 10.7856 9.39963 10.5965 9.29457L9.2954 10.5975C9.52591 11.013 9.65718 11.4911 9.65718 12C9.65718 13.599 8.36093 14.8952 6.76194 14.8952C5.16294 14.8952 3.8667 13.599 3.8667 12C3.8667 10.401 5.16294 9.10474 6.76194 9.10474C7.27055 9.10474 7.74854 9.23589 8.16392 9.46622L9.46569 8.1626C9.23572 7.74747 9.1048 7.26987 9.1048 6.76169C9.1048 5.1627 10.401 3.86646 12 3.86646C13.599 3.86646 14.8953 5.1627 14.8953 6.76169C14.8953 7.27051 14.764 7.74867 14.5335 8.16417L15.8358 9.46641C16.2512 9.23596 16.7293 9.10474 17.2381 9.10474C18.8371 9.10474 20.1333 10.401 20.1333 12C20.1333 13.599 18.8371 14.8952 17.2381 14.8952C15.6391 14.8952 14.3429 13.599 14.3429 12C14.3429 11.4913 14.4741 11.0132 14.7044 10.5978L13.402 9.29543C13.2133 9.4001 13.0116 9.48429 12.8 9.545V14.455C14.0099 14.8021 14.8953 15.9168 14.8953 17.2383C14.8953 18.8373 13.599 20.1335 12 20.1335C10.401 20.1335 9.1048 18.8373 9.1048 17.2383C9.1048 15.9168 9.99013 14.8021 11.2 14.455V9.54498ZM11.9931 15.943C11.281 15.9467 10.7048 16.5252 10.7048 17.2383C10.7048 17.9536 11.2847 18.5335 12 18.5335C12.7154 18.5335 13.2953 17.9536 13.2953 17.2383C13.2953 16.5252 12.7191 15.9467 12.0069 15.943C12.0046 15.9431 12.0023 15.9431 12 15.9431C11.9977 15.9431 11.9954 15.9431 11.9931 15.943ZM5.4667 12C5.4667 12.7153 6.0466 13.2952 6.76194 13.2952C7.47728 13.2952 8.05718 12.7153 8.05718 12C8.05718 11.2846 7.47728 10.7047 6.76194 10.7047C6.0466 10.7047 5.4667 11.2846 5.4667 12ZM15.9429 12C15.9429 12.7153 16.5228 13.2952 17.2381 13.2952C17.9534 13.2952 18.5333 12.7153 18.5333 12C18.5333 11.2846 17.9534 10.7047 17.2381 10.7047C16.5228 10.7047 15.9429 11.2846 15.9429 12Z"
					fill="white"
				/>
			</svg>
		),
	},
	CLOUD_RESOURCE: {
		id: 'CLOUD_RESOURCE',
		name: messages.cloudResource,
		color: (isDarkMode: boolean) => (isDarkMode ? '#8F7EE7' : '#6554C0'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					fill="none"
					d="M6.07585 10.4798C4.70269 10.7573 3.66883 11.9708 3.66883 13.4258C3.66883 15.0857 4.83719 16.4314 6.49712 16.4314M16.6409 16.4314C18.9648 16.4314 20.5 14.5475 20.5 12.2236C20.5 9.89967 18.6161 8.01578 16.2922 8.01578C15.8909 8.01578 15.5027 8.07196 15.1351 8.17688M15.1399 8.18267C14.3348 6.65375 12.7302 5.61133 10.8822 5.61133C8.22631 5.61133 6.07329 7.76435 6.07329 10.4202V10.4803"
					stroke="#fff"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					fill="none"
					d="M14.1963 16.4036C14.1963 17.8203 13.0479 18.9688 11.6312 18.9688C10.2146 18.9688 9.06612 17.8203 9.06612 16.4036C9.06612 14.987 10.2146 13.8385 11.6312 13.8385C13.0479 13.8385 14.1963 14.987 14.1963 16.4036Z"
					stroke="#fff"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
	},
	DATA_PIPELINE: {
		id: 'DATA_PIPELINE',
		name: messages.dataPipeline,
		color: (isDarkMode: boolean) => (isDarkMode ? '#E2483D' : '#FF5630'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					fill="none"
					d="M5.42614 8.00584C6.57734 8.45806 7.87717 7.89141 8.32938 6.7402C8.78159 5.589 8.21495 4.28917 7.06374 3.83696C5.91254 3.38475 4.61271 3.95139 4.1605 5.1026C3.70828 6.2538 4.27493 7.55363 5.42614 8.00584Z"
					stroke="#fff"
					strokeWidth="1.7"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					fill="none"
					d="M16.9334 20.1997C18.0846 20.6519 19.3844 20.0853 19.8366 18.9341C20.2888 17.7828 19.7222 16.483 18.571 16.0308C17.4198 15.5786 16.12 16.1452 15.6677 17.2964C15.2155 18.4477 15.7822 19.7475 16.9334 20.1997Z"
					stroke="#fff"
					strokeWidth="1.7"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					fill="none"
					d="M6.24493 8.56055V11.0306C6.24493 11.5829 6.69264 12.0306 7.24493 12.0306H16.0659C16.6182 12.0306 17.0659 12.4784 17.0659 13.0306V15.2116"
					stroke="#fff"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
	},
	MACHINE_LEARNING_MODEL: {
		id: 'MACHINE_LEARNING_MODEL',
		name: messages.machineLearningModel,
		color: (isDarkMode: boolean) => (isDarkMode ? '#E2483D' : '#FF5630'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					fill="none"
					d="M11.8555 3.01807L15.7255 5.31503L19.6497 7.51807L19.5955 12.0181L19.6497 16.5181L15.7255 18.7211L11.8555 21.0181L7.98547 18.7211L4.06124 16.5181L4.11547 12.0181L4.06124 7.51807L7.98547 5.31503L11.8555 3.01807Z"
					stroke="#fff"
					strokeWidth="1.5"
					strokeLinejoin="round"
				/>
				<path fill="none" d="M4.61222 7.89078L18.8696 16.1906" stroke="#fff" strokeWidth="1.5" />
				<path fill="none" d="M4.85273 16.2901L19.0688 7.95921" stroke="#fff" strokeWidth="1.5" />
				<path fill="none" d="M11.7317 20.2989L11.7317 3.24756" stroke="#fff" strokeWidth="1.5" />
				<path
					fill="#FF5630"
					d="M10.7933 14.6374C12.1126 15.1556 13.6021 14.5062 14.1203 13.187C14.6385 11.8678 13.9892 10.3782 12.67 9.86003C11.3507 9.34181 9.86119 9.99116 9.34297 11.3104C8.82476 12.6296 9.47411 14.1192 10.7933 14.6374Z"
					stroke="#fff"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
	},
	TEMPLATE: {
		id: 'TEMPLATE',
		name: messages.template,
		color: (isDarkMode: boolean) => (isDarkMode ? '#42B2D7' : '#00B8DA'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<mask
					id="path-1-outside-1_2331_289998"
					maskUnits="userSpaceOnUse"
					x="3"
					y="2.99998"
					width="18"
					height="18"
					fill="black"
				>
					<rect fill="white" x="3" y="2.99998" width="18" height="18" />
					<path d="M14.464 11.4051L18.853 11.405C18.8862 11.405 18.9131 11.432 18.9131 11.4652L18.9131 13.5996C18.9131 13.6328 18.8862 13.6597 18.853 13.6597L14.464 13.6597C14.4307 13.6597 14.4038 13.6328 14.4038 13.5996L14.4038 11.4652C14.4038 11.432 14.4307 11.4051 14.464 11.4051Z" />
					<path d="M8.74316 17.8442L8.74317 6.15577C8.74317 5.63419 8.74317 5.3734 8.5922 5.20279C8.57599 5.18447 8.55868 5.16716 8.54036 5.15096C8.36975 4.99998 8.10896 4.99998 7.58738 4.99998C7.0658 4.99999 6.80501 4.99999 6.63439 5.15096C6.61608 5.16717 6.59877 5.18448 6.58256 5.2028C6.43159 5.37341 6.43159 5.6342 6.43159 6.15578L6.43159 17.8442C6.43159 18.3658 6.43159 18.6266 6.58256 18.7972C6.59877 18.8155 6.61608 18.8328 6.6344 18.849C6.805 19 7.06579 19 7.58735 19C8.10894 19 8.36973 19 8.54035 18.849C8.55866 18.8328 8.57598 18.8155 8.59219 18.7972C8.74316 18.6266 8.74316 18.3658 8.74316 17.8442Z" />
				</mask>
				<path
					d="M9.89457 6.35349C9.4795 6.35349 9.14302 6.68998 9.14302 7.10505C9.14303 7.52012 9.47951 7.8566 9.89458 7.8566L9.89457 6.35349ZM16.0626 7.10502L16.0626 6.35347L16.0626 7.10502ZM16.8141 7.85657L16.0626 7.85657L16.0626 7.85657L16.8141 7.85657ZM16.0626 10.3539C16.0626 10.7689 16.399 11.1054 16.8141 11.1054C17.2292 11.1054 17.5657 10.7689 17.5657 10.3539L16.0626 10.3539ZM3.99996 6.4679C3.58489 6.46792 3.24843 6.80442 3.24845 7.21949C3.24847 7.63456 3.58497 7.97103 4.00004 7.97101L3.99996 6.4679ZM4.94361 7.97096C5.35868 7.97094 5.69515 7.63444 5.69513 7.21937C5.69511 6.80429 5.35861 6.46783 4.94354 6.46785L4.94361 7.97096ZM9.89458 7.8566L16.0626 7.85658L16.0626 6.35347L9.89457 6.35349L9.89458 7.8566ZM16.0626 7.85657L16.0626 10.3539L17.5657 10.3539L17.5657 7.85657L16.0626 7.85657ZM16.0626 7.85658L16.0626 7.85657L17.5657 7.85657C17.5657 7.02643 16.8927 6.35347 16.0626 6.35347L16.0626 7.85658ZM4.00004 7.97101L4.94361 7.97096L4.94354 6.46785L3.99996 6.4679L4.00004 7.97101ZM18.853 11.405L18.853 9.90194L18.853 11.405ZM14.464 11.4051L14.464 12.9082L14.464 11.4051ZM14.4038 11.4652L12.9007 11.4652L12.9007 11.4652L14.4038 11.4652ZM14.4038 13.5996L15.9069 13.5996L15.9069 13.5996L14.4038 13.5996ZM14.464 13.6597L14.464 15.1628L14.464 15.1628L14.464 13.6597ZM18.853 13.6597L18.853 12.1566L18.853 12.1566L18.853 13.6597ZM18.9131 13.5996L20.4163 13.5996L20.4163 13.5996L18.9131 13.5996ZM18.9131 11.4652L17.41 11.4652L17.41 11.4652L18.9131 11.4652ZM8.74317 6.15577L7.24006 6.15577L7.24006 6.15577L8.74317 6.15577ZM8.74316 17.8442L10.2463 17.8442L10.2463 17.8442L8.74316 17.8442ZM6.43159 17.8442L7.9347 17.8442L7.9347 17.8442L6.43159 17.8442ZM6.43159 6.15578L4.92848 6.15578L4.92848 6.15578L6.43159 6.15578ZM6.58256 5.2028L7.70823 6.19889L7.70825 6.19887L6.58256 5.2028ZM7.58738 4.99998L7.58738 6.50309L7.58738 4.99998ZM6.63439 5.15096L5.6383 4.02529L5.63829 4.0253L6.63439 5.15096ZM8.5922 5.20279L7.46651 6.19887L7.46653 6.19888L8.5922 5.20279ZM8.54036 5.15096L7.54427 6.27663L7.5443 6.27665L8.54036 5.15096ZM7.58735 19L7.58732 20.5031L7.58735 19ZM6.6344 18.849L5.6383 19.9747L5.6383 19.9747L6.6344 18.849ZM6.58256 18.7972L7.70824 17.8011L7.70824 17.8011L6.58256 18.7972ZM8.54035 18.849L9.53642 19.9747L9.53642 19.9747L8.54035 18.849ZM8.59219 18.7972L7.46652 17.8011L7.46652 17.8011L8.59219 18.7972ZM18.853 9.90194L14.4639 9.90195L14.464 12.9082L18.853 12.9081L18.853 9.90194ZM12.9007 11.4652L12.9007 13.5996L15.9069 13.5996L15.9069 11.4652L12.9007 11.4652ZM14.464 15.1628L18.853 15.1628L18.853 12.1566L14.4639 12.1566L14.464 15.1628ZM20.4163 13.5996L20.4163 11.4652L17.41 11.4652L17.41 13.5996L20.4163 13.5996ZM18.853 15.1628C19.7163 15.1628 20.4163 14.463 20.4163 13.5996L17.41 13.5996C17.41 12.8026 18.0561 12.1566 18.853 12.1566L18.853 15.1628ZM12.9007 13.5996C12.9007 14.4629 13.6006 15.1628 14.464 15.1628L14.4639 12.1566C15.2609 12.1566 15.9069 12.8027 15.9069 13.5996L12.9007 13.5996ZM14.4639 9.90195C13.6006 9.90196 12.9007 10.6018 12.9007 11.4652L15.9069 11.4652C15.9069 12.2621 15.2609 12.9082 14.464 12.9082L14.4639 9.90195ZM18.853 12.9081C18.0561 12.9082 17.41 12.2621 17.41 11.4652L20.4163 11.4652C20.4163 10.6018 19.7164 9.90193 18.853 9.90194L18.853 12.9081ZM7.24006 6.15577L7.24006 17.8442L10.2463 17.8442L10.2463 6.15577L7.24006 6.15577ZM7.9347 17.8442L7.93469 6.15578L4.92848 6.15578L4.92848 17.8442L7.9347 17.8442ZM7.93469 6.15578C7.93469 6.0202 7.93478 5.92531 7.93664 5.84611C7.93752 5.80852 7.93868 5.78111 7.9399 5.76104C7.94112 5.74089 7.94214 5.73268 7.94207 5.73321C7.942 5.73377 7.94027 5.74781 7.93493 5.77157C7.9295 5.79569 7.91973 5.83268 7.90261 5.8783C7.88522 5.92465 7.86087 5.97828 7.82715 6.0354C7.79317 6.09297 7.75326 6.148 7.70823 6.19889L5.45689 4.20671C5.09945 4.61065 4.99651 5.05936 4.95885 5.36214C4.92575 5.6282 4.92848 5.93394 4.92848 6.15578L7.93469 6.15578ZM7.58737 3.49688C7.36553 3.49688 7.05979 3.49415 6.79374 3.52725C6.49095 3.56491 6.04224 3.66785 5.6383 4.02529L7.63049 6.27663C7.5796 6.32166 7.52457 6.36157 7.467 6.39555C7.40988 6.42927 7.35625 6.45362 7.30991 6.47101C7.26428 6.48813 7.22729 6.4979 7.20318 6.50333C7.17941 6.50867 7.16537 6.5104 7.16481 6.51047C7.16428 6.51054 7.17249 6.50952 7.19265 6.5083C7.21272 6.50708 7.24013 6.50592 7.27772 6.50504C7.35691 6.50318 7.45181 6.50309 7.58738 6.50309L7.58737 3.49688ZM7.70825 6.19887C7.68392 6.22636 7.65795 6.25233 7.6305 6.27662L5.63829 4.0253C5.57421 4.08201 5.51362 4.1426 5.45688 4.20672L7.70825 6.19887ZM10.2463 6.15577C10.2463 5.93393 10.249 5.62819 10.2159 5.36214C10.1782 5.05935 10.0753 4.61064 9.71786 4.2067L7.46653 6.19888C7.42149 6.14799 7.38159 6.09296 7.3476 6.03539C7.31388 5.97827 7.28953 5.92464 7.27215 5.87829C7.25503 5.83267 7.24525 5.79568 7.23983 5.77156C7.23448 5.74779 7.23275 5.73375 7.23268 5.7332C7.23262 5.73267 7.23364 5.74088 7.23486 5.76103C7.23608 5.7811 7.23723 5.80851 7.23812 5.8461C7.23998 5.9253 7.24006 6.02019 7.24006 6.15577L10.2463 6.15577ZM7.58738 6.50309C7.72296 6.50309 7.81786 6.50318 7.89705 6.50504C7.93464 6.50592 7.96205 6.50708 7.98212 6.50829C8.00227 6.50952 8.01048 6.51053 8.00995 6.51047C8.0094 6.5104 7.99536 6.50867 7.97159 6.50332C7.94747 6.4979 7.91049 6.48812 7.86486 6.471C7.81852 6.45362 7.76489 6.42927 7.70776 6.39555C7.65019 6.36157 7.59516 6.32166 7.54427 6.27663L9.53645 4.02528C9.1325 3.66784 8.6838 3.5649 8.38101 3.52724C8.11495 3.49415 7.80921 3.49688 7.58737 3.49688L7.58738 6.50309ZM9.71788 4.20671C9.66115 4.1426 9.60055 4.08201 9.53643 4.02526L7.5443 6.27665C7.5168 6.25232 7.49083 6.22634 7.46651 6.19887L9.71788 4.20671ZM7.58738 17.4969C7.4518 17.4969 7.35691 17.4968 7.27772 17.4949C7.24013 17.494 7.21272 17.4929 7.19265 17.4917C7.1725 17.4904 7.16429 17.4894 7.16482 17.4895C7.16538 17.4896 7.17942 17.4913 7.20318 17.4966C7.2273 17.5021 7.26428 17.5118 7.30991 17.529C7.35625 17.5463 7.40988 17.5707 7.46701 17.6044C7.52458 17.6384 7.5796 17.6783 7.63049 17.7233L5.6383 19.9747C6.04224 20.3321 6.49093 20.435 6.79371 20.4727C7.05976 20.5058 7.36549 20.5031 7.58732 20.5031L7.58738 17.4969ZM4.92848 17.8442C4.92848 18.066 4.92576 18.3718 4.95885 18.6378C4.99651 18.9406 5.09944 19.3893 5.45687 19.7932L7.70824 17.8011C7.75327 17.852 7.79318 17.907 7.82716 17.9646C7.86088 18.0217 7.88523 18.0753 7.90261 18.1217C7.91973 18.1673 7.92951 18.2043 7.93493 18.2284C7.94027 18.2522 7.942 18.2662 7.94207 18.2668C7.94214 18.2673 7.94112 18.2591 7.9399 18.2389C7.93868 18.2189 7.93752 18.1915 7.93664 18.1539C7.93478 18.0747 7.9347 17.9798 7.9347 17.8442L4.92848 17.8442ZM7.63049 17.7233C7.65797 17.7477 7.68394 17.7736 7.70824 17.8011L5.45687 19.7932C5.51359 19.8573 5.57418 19.9179 5.6383 19.9747L7.63049 17.7233ZM7.58732 20.5031C7.80917 20.5031 8.11491 20.5058 8.38097 20.4727C8.68375 20.4351 9.13246 20.3322 9.53642 19.9747L7.54428 17.7233C7.59517 17.6783 7.65019 17.6384 7.70776 17.6044C7.76489 17.5707 7.81852 17.5464 7.86486 17.529C7.91049 17.5119 7.94748 17.5021 7.97159 17.4967C7.99536 17.4913 8.0094 17.4896 8.00996 17.4895C8.01048 17.4894 8.00227 17.4905 7.98212 17.4917C7.96205 17.4929 7.93464 17.4941 7.89705 17.4949C7.81785 17.4968 7.72296 17.4969 7.58738 17.4969L7.58732 20.5031ZM7.24006 17.8442C7.24006 17.9798 7.23997 18.0747 7.23811 18.1539C7.23723 18.1915 7.23607 18.2189 7.23485 18.2389C7.23363 18.2591 7.23261 18.2673 7.23268 18.2668C7.23275 18.2662 7.23448 18.2522 7.23982 18.2284C7.24525 18.2043 7.25502 18.1673 7.27214 18.1217C7.28953 18.0753 7.31388 18.0217 7.3476 17.9646C7.38158 17.907 7.42149 17.852 7.46652 17.8011L9.71786 19.7933C10.0753 19.3893 10.1782 18.9406 10.2159 18.6378C10.249 18.3718 10.2463 18.066 10.2463 17.8442L7.24006 17.8442ZM9.53642 19.9747C9.60052 19.918 9.66111 19.8574 9.71786 19.7933L7.46652 17.8011C7.49084 17.7736 7.51681 17.7476 7.54427 17.7233L9.53642 19.9747Z"
					fill="white"
					mask="url(#path-1-outside-1_2331_289998)"
				/>
			</svg>
		),
	},
	UI_ELEMENT: {
		id: 'UI_ELEMENT',
		name: messages.uiElement,
		color: (isDarkMode: boolean) => (isDarkMode ? '#F5CD47' : '#FF8B00'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<mask id="path-1-inside-1_1403_23012" fill="white">
					<rect x="2.83353" y="13.6489" width="6.97358" height="7.36887" rx="1" />
				</mask>
				<rect
					fill="none"
					x="2.83353"
					y="13.6489"
					width="6.97358"
					height="7.36887"
					rx="1"
					stroke="#fff"
					strokeWidth="3.2"
					mask="url(#path-1-inside-1_1403_23012)"
				/>
				<mask id="path-2-inside-2_1403_23012" fill="white">
					<rect x="2.83353" y="3.01807" width="18.5455" height="8.59702" rx="1" />
				</mask>
				<rect
					fill="none"
					x="2.83353"
					y="3.01807"
					width="18.5455"
					height="8.59702"
					rx="1"
					stroke="#fff"
					strokeWidth="3.2"
					mask="url(#path-2-inside-2_1403_23012)"
				/>
				<mask id="path-3-inside-3_1403_23012" fill="white">
					<rect x="11.5089" y="13.6489" width="9.87006" height="7.36887" rx="1" />
				</mask>
				<rect
					fill="none"
					x="11.5089"
					y="13.6489"
					width="9.87006"
					height="7.36887"
					rx="1"
					stroke="#fff"
					strokeWidth="3.2"
					mask="url(#path-3-inside-3_1403_23012)"
				/>
			</svg>
		),
	},
	WEBSITE: {
		id: 'WEBSITE',
		name: messages.website,
		color: (isDarkMode: boolean) => (isDarkMode ? '#2ABB7F' : '#36B37E'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<mask id="path-5-inside-5_1403_23012" fill="white">
					<rect width="24" height="24" rx="3" fill="#22A06B" />
				</mask>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12 18.375C12.8372 18.375 13.6662 18.2101 14.4396 17.8897C15.2131 17.5694 15.9158 17.0998 16.5078 16.5078C17.0998 15.9158 17.5694 15.2131 17.8897 14.4396C18.2101 13.6662 18.375 12.8372 18.375 12C18.375 11.1628 18.2101 10.3338 17.8897 9.56039C17.5694 8.78694 17.0998 8.08417 16.5078 7.49219C15.9158 6.90022 15.2131 6.43064 14.4396 6.11027C13.6662 5.78989 12.8372 5.625 12 5.625C10.3092 5.625 8.68774 6.29665 7.49219 7.49219C6.29665 8.68774 5.625 10.3092 5.625 12C5.625 13.6908 6.29665 15.3123 7.49219 16.5078C8.68774 17.7033 10.3092 18.375 12 18.375ZM11.3625 17.0554C10.1302 16.9017 8.99657 16.303 8.17476 15.372C7.35294 14.441 6.8996 13.2418 6.9 12C6.9 11.6047 6.951 11.2286 7.03387 10.8589L10.0875 13.9125V14.55C10.0875 15.2513 10.6613 15.825 11.3625 15.825V17.0554ZM15.7612 15.4361C15.6804 15.1785 15.5192 14.9535 15.3012 14.7941C15.0833 14.6346 14.82 14.5491 14.55 14.55H13.9125V12.6375C13.9125 12.2869 13.6256 12 13.275 12H9.45V10.725H10.725C11.0756 10.725 11.3625 10.4381 11.3625 10.0875V8.8125H12.6375C13.3387 8.8125 13.9125 8.23875 13.9125 7.5375V7.27612C15.7804 8.03475 17.1 9.86437 17.1 12C17.1 13.326 16.59 14.5309 15.7612 15.4361Z"
					fill="white"
				/>
			</svg>
		),
	},
	DATASET: {
		id: 'DATASET',
		name: messages.dataset,
		color: (isDarkMode: boolean) => (isDarkMode ? '#DA62AC' : '#CD519D'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					d="M3 0H21C22.7 0 24 1.3 24 3V21C24 22.7 22.7 24 21 24H3C1.3 24 0 22.7 0 21V3C0 1.3 1.3 0 3 0Z"
					fill="none"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.5 6.5V17.5H17.5V6.5H6.5ZM6 5C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5H6Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M18 10.75H5V9.25H18V10.75Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M18 14.75H5V13.25H18V14.75Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.75 5L12.75 18L11.25 18L11.25 5L12.75 5Z"
					fill="currentColor"
				/>
			</svg>
		),
	},
	DATA_PRODUCT: {
		id: 'DATA_PRODUCT',
		name: messages.dataProduct,
		color: (isDarkMode: boolean) => (isDarkMode ? '#2ABB7F' : '#2ABB7F'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					d="M0 21V3c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H3c-1.7 0-3-1.3-3-3Z"
					fill="none"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.1 5a.9.9 0 0 1 .9-.9h4v1.8H5.9V9H4.1V5ZM19 4.1a.9.9 0 0 1 .9.9v4h-1.8V5.9H15V4.1h4ZM19.9 19a.9.9 0 0 1-.9.9h-4v-1.8h3.1V15h1.8v4ZM5 19.9a.9.9 0 0 1-.9-.9v-4h1.8v3.1H9v1.8H5Z"
					fill="currentColor"
				/>
				<path
					d="M11 8h2v2h-2V8ZM8 11h2v2H8v-2ZM11 14h2v2h-2v-2ZM14 11h2v2h-2v-2Z"
					fill="currentColor"
				/>
			</svg>
		),
	},
	DASHBOARD: {
		id: 'DASHBOARD',
		name: messages.dashboard,
		color: (isDarkMode: boolean) => (isDarkMode ? '#8777D9' : '#8777D9'),
		icon: (props: CustomGlyphProps) => (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					d="M0 21V3c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H3c-1.7 0-3-1.3-3-3Z"
					fill="none"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.5 17.5h13v-11h-13v11ZM4 18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4 9.25h8v1.5H4v-1.5ZM12 13.25h8v1.5h-8v-1.5Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.75 6v13h-1.5V6h1.5Z"
					fill="currentColor"
				/>
			</svg>
		),
	},
	OTHER: {
		id: 'OTHER',
		name: messages.other,
		color: (isDarkMode: boolean) => (isDarkMode ? '#388BFF' : '#0065FF'),
		icon: OtherIcon,
	},
};

export default componentTypesMetadata;
